import { Component } from '@angular/core';

@Component({
  selector: 'braidsbook-hairstyle-details-skeleton',
  templateUrl: './hairstyle-details-skeleton.component.html',
  styles: ``
})
export class HairstyleDetailsSkeletonComponent {

}

